export default "__VITE_ASSET__DE1L5Pkx__"